<script setup>
const props = defineProps({
  text: {
    type: String,
    required: false,
    default: `Coming soon to web. This feature now on <a href="https://vrumble.app.link/uzC4kgZVDmb" target="_blank" class="tw-underline">the Nexus Mobile App (iOS/Android)</a>.`,
  },
  closeDelay: {
    type: Number,
    required: false,
    default: undefined,
  },
});

const tooltipVisible = defineModel({
  prop: "modelValue",
  event: "update:modelValue",
  type: Boolean,
  default: undefined,
});
</script>

<template>
  <v-tooltip
    v-model="tooltipVisible"
    activator="parent"
    width="200"
    :close-delay="closeDelay"
    class="tw-text-center"
    content-class="!tw-text-white action-tooltip"
    scroll-strategy="close"
    z-index="2041"
  >
    <div v-html="text" />
  </v-tooltip>
</template>

<style lang="postcss">
.action-tooltip {
  pointer-events: initial !important;
  background: rgba(45, 45, 45, 0.5) !important;
  backdrop-filter: blur(10px);
}
</style>
